<template>
  <div class="page-cancellation">
    <base-section>
      <div class="container">
        <div class="row justify-content-center text-center">
          <div class="col d-flex justify-content-center" v-if="!cancelled">
            <base-card class="base-card-login">
              <h2 class="title title-big title-light title-caps text-center">{{$t('views.cancellation.modal.title')}}</h2>
              <p class="text text-bigger text-center">{{$t('views.cancellation.modal.text')}}</p>
              <p class="text text-red text-center" v-if="error">{{ message }}</p>

              <base-button
                class="base-button-pri"
                :disabled="loading"
                @click="confirmCancellation"
              >{{$t('buttons.confirm_cancel_reservation')}}</base-button>
            </base-card>
          </div>

          <div class="cancelled-content" v-if="cancelled">
            <p class="subhead subhead-light subhead-caps text-center">{{$t('views.cancellation.header.subhead')}}</p>
            <h2 class="title title-bigger title-semi text-center">{{$t('views.cancellation.header.title')}}</h2>
            <hr class="title-separator title-separator-center">
            <p class="text text-bigger text-center">{{$t('views.cancellation.header.text')}} <a href="mailto:rio-tinto-reservations@maxaviation.com">rio-tinto-reservations@maxaviation.com</a>.</p>
            <base-button class="base-button-pri" @click="newReservation">{{$t('buttons.new_reservation')}}</base-button>
          </div>
        </div>
      </div>
    </base-section>
  </div>

  <teleport to=".simply-flights-frontend">
    <base-loading v-if="loading"></base-loading>
  </teleport>
</template>

<script>
import { mapState } from 'vuex'

export default {
  data() {
    return {
      cancelled: false,
      error: false,
      message: ''
    }
  },
  computed: {
    ...mapState( 'cancellationModule', [
      'loading',
      'error'
    ] ),

    passengerParams() {
      const { passengerGroupId, departureReservationId, returnReservationId  } = this.$route.query

      return {
        passengerGroupId: Number(passengerGroupId),
        departureReservationId: Number(departureReservationId),
        returnReservationId: Number(returnReservationId),
      }
    }
  },
  methods: {
    async confirmCancellation() {

      this.cancelled = false
      this.error = false
      this.message = ''

      try {
        const result = await this.$store.dispatch(
          'cancellationModule/cancelReservation',
          {
            passengerGroupId: this.passengerParams.passengerGroupId,
            departureReservationId: this.passengerParams.departureReservationId,
            returnReservationId: this.passengerParams.returnReservationId
          }
        )

        if( result.code === 'invalid' ) {
          this.cancelled = false
          this.error = true
          this.message = this.$t( 'errors.invalid_passenger_group_id' )
        }

        if( result.code === 'not_found' ) {
          this.cancelled = false
          this.error = true
          this.message = this.$t( 'errors.reservation_already_cancelled' )
        }

        if( result.code === 'failed' ) {
          this.cancelled = false
          this.error = true
          this.message = this.$t( 'errors.reservation_cancellation_failed' )
        }

        if( result.code === 'cancelled' ) {
          this.cancelled = true
          this.error = false
        }

      } catch( error ) {
        console.error( error )
      }
    },
    newReservation() {
      this.$router.push( '/reservation-options' )
    }
  }
}
</script>